var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, Chip, Link, Tooltip } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { RoundActionIconButton } from "../components/Buttons/ActionIconButton/RoundActionIconButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useState } from "react";
import { useEffect } from "react";
import { ChatSettingsButton } from "./ChatSettingsButton";
export function LLMChatButtons({ handleClickHide, handleClickReset, handleClickDownload, textColor, disableReset, userId, systemPrompt, setSystemPrompt, temperature, setTemperature, model, setModel, }) {
    //@ts-ignore
    const isElectron = !!window.electron;
    const [hasSysPromptPermission, setHasSysPromptPermission] = useState(false);
    const checkSysPromptPermission = (userId) => __awaiter(this, void 0, void 0, function* () {
        if (process.env.NODE_ENV === "development") {
            setHasSysPromptPermission(true);
            return;
        }
        const response = yield fetch(`${window.location.origin}/v1/chat/check_id`, {
            method: "POST",
            body: JSON.stringify({ id: userId }),
        });
        if (!response.ok)
            return;
        const data = yield response.json();
        setHasSysPromptPermission(data.found);
    });
    useEffect(() => {
        if (isElectron)
            return;
        checkSysPromptPermission(userId);
    }, [userId]);
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%", // Make it full width of the parent
        } }, { children: [_jsx(Box, Object.assign({ sx: { zIndex: 1000 } }, { children: _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Hide", onClick: handleClickHide, baseColor: textColor }, { children: _jsx(ExpandLessIcon, { style: { transform: "rotate(90deg)" }, fontSize: "small" }) })) })), _jsx(Tooltip, Object.assign({ arrow: true, enterDelay: 500, title: _jsxs(_Fragment, { children: ["This feature is a prototype and still in active development. Help us improve it by", " ", _jsx(Link, Object.assign({ sx: {
                                color: "inherit",
                                textDecoration: "underline",
                                cursor: "pointer",
                            }, href: "https://discord.gg/8v72kEwJZZ", target: "_blank", rel: "noreferrer" }, { children: "sharing your feedback" })), "!"] }) }, { children: _jsx(Chip, { label: "v0.1.0", 
                    // color="primary"
                    size: "small", sx: {
                        mr: "5px",
                        // height: "27px",
                        color: "white",
                        backgroundColor: "#6a6767",
                    } }) })), _jsxs(Box, Object.assign({ sx: { display: "flex" } }, { children: [_jsx(ChatSettingsButton, { textColor: textColor, systemPrompt: systemPrompt, setSystemPrompt: setSystemPrompt, temperature: temperature, setTemperature: setTemperature, model: model, setModel: setModel, hasSysPromptPermission: hasSysPromptPermission }), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Reset chat", onClick: handleClickReset, baseColor: textColor, disabled: disableReset }, { children: _jsx(RestartAltIcon, { fontSize: "small" }) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Download chat", onClick: handleClickDownload, baseColor: textColor, disabled: disableReset }, { children: _jsx(FileDownloadIcon, { fontSize: "small" }) }))] }))] })));
}
